import { render, staticRenderFns } from "./loginHome.vue?vue&type=template&id=2cfbcb81&scoped=true&"
import script from "./loginHome.vue?vue&type=script&lang=js&"
export * from "./loginHome.vue?vue&type=script&lang=js&"
import style0 from "./loginHome.vue?vue&type=style&index=0&id=2cfbcb81&scoped=true&lang=css&"
import style1 from "./loginHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfbcb81",
  null
  
)

export default component.exports